import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_player-volume-0",
  "use": "icon_player-volume-0-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon_player-volume-0\"><path stroke=\"currentColor\" stroke-linecap=\"round\" d=\"M11 5 6 9H2v6h4l5 4V5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol